import React, {useEffect, useState} from "react";
import Table from "../../../components/fouladyar/table";
import {useDispatch, useSelector} from "react-redux";
import {EmptyStateObject, filterStructure, TableActionsStructure, tableStatics, tableStructure} from "./index";
import {ErrorToaster} from "../../../shared/toaster";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {MdAdd, MdOutlineContentCopy} from "react-icons/md";
import {LuAreaChart} from "react-icons/lu";

import NewAccountImage from "../../../assets/images/mrpropfund/new-account-background.png";
import {toFarsiNumber} from "../../../shared/toFarsiNumber";
import {ConvertGregorianToJalali} from "../../../shared/convertGregorianToJalali";
import {copyToClipboard} from "../../../shared/copyToClipboard";
import {useNavigate} from "react-router";


const AccountList = () => {

    const {t, i18n} = useTranslation();
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isApplyingFilter, setIsApplyingFilter] = useState(false);
    const [pagination, setPagination] = useState({
        itemPerPage: 7,
        currentPage: 1,
        totalItems: 0,
        lastUpdateBy: ''
    })

    const [filter, setFilter] = useState({})

    async function initializeData() {


        try {
            setIsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/review/accounts/mine`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            console.log('data', res)

            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setData(res.data.data)
                setPagination({...pagination, totalItems: res.data.data.totalItems || 9, lastUpdateBy: 'initializer'})
            }

            setIsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        initializeData();
    }, []);



    function AccountItem({username, password, broker, server,balance,metaapi_id,
                             disabled, type, level, investor, createdAt}){
        return(
            <div className={` ${disabled ? 'disabled-account-style' : ''}`}>
                <div className="account-item order-detail-account">
                <div className="account-header">
                    <div className="account-header-title">شماره حساب {toFarsiNumber(username)}</div>
                    {/*<div className="account-header-analysis" onClick={() => {
                        navigate('/history')
                    }}><LuAreaChart size={20} color={"#4F9D81"}/></div>*/}
                </div>
                <div className="account-detail-container">
                    <div className="account-detail-item">
                        <div className="account-detail-key">Username</div>
                        <div className="account-detail-value">
                            {username} <MdOutlineContentCopy className="copy-to-clipboard"  onClick={() => copyToClipboard(username)} size={20} color={"#787878"}/>
                        </div>
                    </div>
                    <div className="account-detail-item">
                        <div className="account-detail-key">Password</div>
                        <div className="account-detail-value">
                            {password} <MdOutlineContentCopy className="copy-to-clipboard" onClick={() => copyToClipboard(password)} size={20} color={"#787878"}/>
                        </div>
                    </div>
                    <div className="account-detail-item">
                        <div className="account-detail-key">Server</div>
                        <div className="account-detail-value">
                            {server} <MdOutlineContentCopy className="copy-to-clipboard"  onClick={() => copyToClipboard(server)} size={20} color={"#787878"}/>
                        </div>
                    </div>
                    <div className="account-detail-item">
                        <div className="account-detail-key">Balance</div>
                        <div className="account-detail-value"> ${balance}</div>
                    </div>
                    <div className="account-detail-item">
                        <div className="account-detail-key">Investor</div>
                        <div className="account-detail-value">
                            {investor} <MdOutlineContentCopy className="copy-to-clipboard"  onClick={() => copyToClipboard(investor)} size={20} color={"#787878"}/>
                        </div>
                    </div>
                    <div className="account-detail-item">
                        <div className="account-detail-key">Broker</div>
                        <div className="account-detail-value">
                            {broker?.name}
                        </div>
                    </div>
                    <div className="account-detail-item">
                        <div className="account-detail-key">تاریخ خرید</div>
                        <div className="account-detail-value"> {ConvertGregorianToJalali(createdAt)}</div>
                    </div>
                    <div className="account-detail-item">
                        <div className="account-detail-key">نوع حساب</div>
                        <div className={`account-detail-value ${type === 'real' ? 'green-color' : 'yellow-color'}`}> {type === "real" ? "Real" : "Demo"}</div>
                    </div>
                    <div className="account-detail-item">
                        <div className="account-detail-key">سطح پیشرفت</div>
                        <div className="account-detail-value">{level}</div>
                    </div>
                </div>
            </div>
                {
                    disabled ?
                        <div className="disabled-badge">
                            غیر فعال
                        </div> : ''
                }
            </div>
        )
    }


    return (
        <React.Fragment>

            <div className="accounts-container">
                {
                    data.map(item => {
                        return(
                            <AccountItem
                                disabled={item.status === 'suspended'}
                                username={item.account.username}
                                password={item.account.password}
                                balance={item.account.balance}
                                broker={item.broker}
                                server={item.account.server}
                                metaapi_id={item.account.metaapi_id}
                                type={item.account.type}
                                investor={item.account.investor}
                                createdAt={item.createdAt}
                                level={item.account.level}
                            />
                        )
                    })
                }

                <div className="account-item account-new-item">
                    <div className="new-account-context-container">
                        <div className="new-account-background"> <img src={NewAccountImage} alt={""} /></div>
                        <div className="new-account-title">خرید اکانت</div>
                        <div className="new-account-description">با خرید حساب جدید وارد چالش جذب سرمایه شده و تا ۵۰ هزار دلار برای معامله گری جذب سرمایه کنید</div>
                        <button className="btn btn-secondary  buttons-html5 " type="button" onClick={() => {
                            navigate('/plans')
                        }}>
                            خرید اکانت جدید
                        </button>
                    </div>
                </div>


            </div>


            {/*<Table*/}
            {/*    loading={isLoading}*/}
            {/*    filter={filter}*/}
            {/*    tableData={data}*/}
            {/*    pagination={pagination}*/}
            {/*    tableHeading={tableStatics}*/}
            {/*    tableStructure={tableStructure}*/}
            {/*    filterStructure={filterStructure}*/}
            {/*    tableActionsStructure={TableActionsStructure}*/}
            {/*    emptystate={EmptyStateObject}*/}
            {/*    onItemPerPageChange={(itemPerPage, currentPage) => {*/}
            {/*        setPagination({*/}
            {/*            ...pagination,*/}
            {/*            itemPerPage: itemPerPage,*/}
            {/*            currentPage: currentPage,*/}
            {/*            lastUpdateBy: 'pagination'*/}
            {/*        })*/}
            {/*    }}*/}
            {/*    onCurrentPageChange={(currentPage) => {*/}
            {/*        setPagination({...pagination, currentPage: currentPage, lastUpdateBy: 'pagination'})*/}
            {/*    }}*/}
            {/*    onFilterSubmit={(e) => {*/}
            {/*        setFilter(e);*/}
            {/*    }}*/}
            {/*    onDeleteComplete={async (e) => {*/}
            {/*        await fetchData('filter');*/}
            {/*    }}*/}
            {/*/>*/}
        </React.Fragment>
    );
};

export default AccountList;
